import { render, staticRenderFns } from "./RemainPlaceDialog.vue?vue&type=template&id=656cabb4&scoped=true"
import script from "./RemainPlaceDialog.vue?vue&type=script&lang=js"
export * from "./RemainPlaceDialog.vue?vue&type=script&lang=js"
import style0 from "./RemainPlaceDialog.vue?vue&type=style&index=0&id=656cabb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656cabb4",
  null
  
)

export default component.exports